import { mutatorAction } from "satcheljs";
import { getProactiveDraftsStore } from "../store/store";
import type CopilotTelemetrySession from "owa-copilot-telemetry/lib/CopilotTelemetrySession";

const setCurrentProactiveDraftsTelemetrySessionMutator: (currentTelemetrySession: CopilotTelemetrySession | undefined) => void = mutatorAction("setCurrentProactiveDraftsTelemetrySessionMutator", function setCurrentProactiveDraftsTelemetrySession(currentTelemetrySession: CopilotTelemetrySession | undefined): void {
    const proactiveDraftsStore = getProactiveDraftsStore();
    proactiveDraftsStore.currentTelemetrySession = currentTelemetrySession;
});
export default setCurrentProactiveDraftsTelemetrySessionMutator;
